import { ReactNode } from "react";
import { Navigate, useParams } from "react-router";

type ProtectedRouteProps = {
  children: ReactNode;
  redirectTo?: string;
  accessCondition?: (param?: string) => boolean;
};

export default function ProtectedRoute({
  children,
  redirectTo = "/",
  accessCondition
}: ProtectedRouteProps) {
  const { inboxType } = useParams<{ inboxType?: string }>();

  const hasAccess = accessCondition ? accessCondition(inboxType) : true;
  return hasAccess ? <>{children}</> : <Navigate to={redirectTo} replace />;
}
